import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc'
import timezonePlugin from 'dayjs/plugin/timezone'
import { format } from '@master/services/DateService'

function getYearDifference (paidToDate: number | string | Date, issuedDate: number| string | Date) {
  dayjs.extend(customParseFormat)
  dayjs.extend(utc)
  dayjs.extend(timezonePlugin)
  dayjs.prototype.format = format

  const pDate = dayjs(paidToDate)
  const iDate = dayjs(issuedDate)
  const dateToCompare = dayjs(new Date(pDate.year(), iDate.month(), iDate.date()))
  const isPaidDateLtIssuedDate = pDate.isBefore(dateToCompare)
  const yearDiff = pDate.year() - iDate.year()
  const YR = yearDiff - (isPaidDateLtIssuedDate ? 1 : 0)

  const monthDiff = pDate.month() - iDate.month()
  const isPaidDayLtIssuedDay = pDate.date() < iDate.date()
  const modParam1 = monthDiff + 12 - (isPaidDayLtIssuedDay ? 1 : 0)
  const MTH = modParam1 % 12

  const yrResult = YR === 0 ? 1 : (YR + (MTH > 0 ? 1 : 0))

  return yrResult
}

export function IsLessThanEqualAYear (paidToDate: number | string | Date, issuedDate: number| string | Date) {
  const premiumYear = getYearDifference(paidToDate, issuedDate)

  return premiumYear <= 1
}

export function GetCommissionType (paidToDate: number | string | Date, issuedDate: number| string | Date) {
  return IsLessThanEqualAYear(paidToDate, issuedDate) ? 'Year1' : 'Renewal'
}

export function GetPremiumYear (paidToDate: number | string | Date, issuedDate: number| string | Date) {
  // formula reference:
  // YR = Year (PaidToDate ) - Year (IssuedDate) - If (PaidToDate  < Date (Month (IssuedDate); Day (IssuedDate); Year (PaidToDate )); 1; 0);
  // MTH = Mod (Month (PaidToDate ) - Month(IssuedDate) + 12 - If (Day (PaidToDate ) < Day (IssuedDate); 1; 0); 12)  ];
  // "Year" & Case ( YR = 0 ; 1  ;YR + Case( MTH > 0 ; 1 ; 0 )  )
  // Result will be Year1 for example
  const yrResult = getYearDifference(paidToDate, issuedDate)

  return 'Year' + yrResult
}
